import { axios, BaseApiUrl} from '../../axios_config';


//查询收货报表
export const getTFSignForTaskAsync = params => {
    return axios.post(`${BaseApiUrl}/TFSignFor/GetTFSignForTaskAsync`, params);
};

//导出收货
export const exportSignForTaskAsyncOut = `${BaseApiUrl}/TFSignFor/SignForTaskAsyncOut`;

//查询收货列表基础数据
export const getSignForTaskBasis = params => {
    return axios.get(`${BaseApiUrl}/TFSignFor/GetSignForTaskBasis`, { params: params });
};

//查询收货箱明细
export const getTFSignForTaskcByTFSignForID = params => {
    return axios.get(`${BaseApiUrl}/TFSignFor/GetTFSignForTaskcByTFSignForID`, { params: params });
};